// BrowseCourses.tsx
import React, { useEffect } from 'react';
import './BrowseCourses.css';
import CourseCard from '@/Components/CourseCard/CourseCard';
import { useLearningsStore } from '@/stores/LearnerStore/LearningsStore';
import { LoadingSpinner, ErrorDisplay } from '@/Components/common';

const BrowseCourses: React.FC = () => {
  const {
    browseCourses,
    loadingBrowse,
    errorBrowse,
    fetchBrowseCourses,
  } = useLearningsStore();

  // Fetch data on mount
  useEffect(() => {
    fetchBrowseCourses();
  }, [fetchBrowseCourses]);

  // Loading state
  if (loadingBrowse) {
    return (
      <LoadingSpinner
        fullScreen
        size="lg"
      />
    );
  }

  // Error state
  if (errorBrowse) {
    return (
      <ErrorDisplay
        fullScreen
        title="Failed to Load Browse Courses"
        message={errorBrowse}
        type="error"
        showRetry
        onRetry={fetchBrowseCourses}
      />
    );
  }

  return (
    <div className="browse-courses-container">
      <div className="browse-courses-header">
        <h1 className='page-title'>Browse Courses</h1>
        <p className='page-subtitle'>Explore our wide range of courses and start learning today</p>
      </div>
      <div className="browse-courses-grid">
        {browseCourses?.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default BrowseCourses;
